import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDiscard = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8.03093 5.57874L18.3422 5.57874C19.1581 5.57874 19.9405 5.94335 20.5174 6.59237C21.0944 7.2414 21.4185 8.12166 21.4185 9.03952L21.4185 15.9611C21.4185 16.7932 21.1521 17.5943 20.6725 18.2203L8.03093 5.57874ZM17.3486 19.4219L4.19477 6.26806C4.07777 6.36651 3.96648 6.47477 3.86195 6.59237C3.28504 7.2414 2.96094 8.12166 2.96094 9.03952L2.96094 15.9611C2.96094 16.8789 3.28504 17.7592 3.86195 18.4082C4.43886 19.0573 5.22132 19.4219 6.03719 19.4219L17.3486 19.4219ZM8.49819 15.2689C8.49819 14.5044 7.87841 13.8846 7.11388 13.8846C6.34934 13.8846 5.72957 14.5044 5.72957 15.2689C5.72957 16.0335 6.34934 16.6532 7.11388 16.6532C7.87841 16.6532 8.49819 16.0335 8.49819 15.2689Z",
		fill: "white"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M1.48235 3.29289C1.87287 2.90237 2.50604 2.90237 2.89656 3.29289L20.8966 21.2929C21.2871 21.6834 21.2871 22.3166 20.8966 22.7071C20.506 23.0976 19.8729 23.0976 19.4823 22.7071L1.48235 4.70711C1.09182 4.31658 1.09182 3.68342 1.48235 3.29289Z",
		fill: "white"
	})]
});
const ForwardRef = forwardRef(SvgDiscard);
export default ForwardRef;
